/**
 * useBackpackCampaign Hook
 *
 * Fetches and manages Backpack wallet campaign status.
 * Returns campaign details including:
 * - Whether campaign is active
 * - User's bonus points earned
 * - Remaining bonus available
 * - Campaign dates
 */

import { useQuery } from '@tanstack/react-query';

import { getBackpackCampaignStatus } from '@/api/auth';

export function useBackpackCampaign() {
  const query = useQuery({
    queryKey: ['backpackCampaign'],
    queryFn: async () => {
      const response = await getBackpackCampaignStatus();
      if (response.code !== 0) {
        throw new Error(response.message || 'Failed to fetch campaign status');
      }
      return response.data;
    },
    staleTime: 30 * 1000, // Cache for 30 seconds
    refetchInterval: 60 * 1000, // Refetch every 60 seconds to keep countdown updated
  });

  return {
    campaignData: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
